import actionFactoryTypes from '../actions/actionsFactory/types';

export const INITIAL_STATE = {
  rechargeProcut: {
    name: 'Crypto',
  },
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actionFactoryTypes.SET_RECHARGE_CURRENT_PRODUCT:
      return { ...state, rechargeProcut: action.data };
    default:
      return state;
  }
};
